<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>{{ 'Egreso de bodega ' + (documento ? documento : '') }}</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="guardar" class="btn-success">
            <i class="fa fa-save"></i><span>Guardar</span>
          </button>
          <button @click="cerrar" class="btn-danger btn--text">
            <i class="fa fa-times"></i><span>Cancelar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="datepicker-field">
            <VueCtkDateTimePicker
              id="fecha_transaccion"
              v-model="form.fecha_transaccion"
              locale="es"
              no-label
              button-now-translation="Ahora"
              format="YYYY-MM-DD HH:mm:ss"
              formatted="YYYY-MM-DD HH:mm:ss"
              label="Seleccione fecha..."
            />
            <label>Fecha transacción:</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              :filterable="false"
              @input="inputBodega"
              label="descripcion"
              placeholder="Seleccione..."
              :options="bodegas"
              id="bodegas"
              v-model="selectedBodega"
            ></v-select>
            <label for="bodegas">Bodega:</label>
          </div>
        </div>
      </div>   
      <div class="col-xs-12 col-md-8 mb-2">
        <div class="form-field">
          <textarea-field
            id="nota"
            placeholder="Escriba..."                    
            v-model="form.nota"
          >
            <span>Nota:</span>
          </textarea-field>
        </div>
      </div>        
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <tabla-egreso-bodega 
              v-model="form.detalles"
            ></tabla-egreso-bodega>
          </div>
        </div>        
      </div>
    </div>
    <div class="modal-buttons" v-show="false">
      <button @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button @click="cerrar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    egresoBodegaId: {
      required: true
    },
    bodegas: {
      required: true
    },
    documento: {
      required: true
    }
  },
  data: function() {
    return {
      selectedBodega: null,
      form: {
        fecha_transaccion: null,
        nota: '',
        bodega_id: null,
        detalles: []
      }
    }
  },
  methods: {
    validarCampos: function() {
      if(this.form.fecha_transaccion == null || this.form.bodega_id == null){
        swal('La fecha y la bodega son obligatorias', 'Aviso', 'warning');
        return false;
      }
      if(this.form.nota.length > 1000){
        swal('La nota solo puede tener hasta mil caracteres', 'Aviso', 'warning');
        return false;
      }
      if(this.form.detalles.length == 0){
        swal('Debe ingresar al menos un item', 'Aviso', 'warning');
        return false;
      }
      return true;
    },
    guardar: function() {
      if(!this.validarCampos())
        return;
      swal({
        title: "¿Desea guardar el egreso de bodega?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar", 
      }).then((result) => {
        if (result.value) {
          let urlApi = `${url}/egreso-bodega/`;
          urlApi += this.egresoBodegaId != null
            ? `editar/${this.egresoBodegaId}`
            : 'guardar';
          axios 
            .post(urlApi, this.form)
            .then(response => {
              swal('Realizado', 'El egreso de bodega ha sido guardado', 'success');
                this.$emit('guardar');
            })
            .catch(error => {
              swal('Error', 'No se pudo guardar el egreso de bodega', 'error');
            });
        }
      });  
    },
    cargarEgresoBodega: function() {
      let urlApi = `${url}/egreso-bodega/cargar/${this.egresoBodegaId}`;
      axios
        .get(urlApi)
        .then(response => {
          let egreso = response.data;
          this.form.fecha_transaccion = egreso.fecha_transaccion;
          this.form.nota = egreso.nota;
          this.selectedBodega = egreso.bodega;
          this.form.bodega_id = egreso.bodega_id;
          this.form.detalles.splice(0, this.form.detalles.length);
          for(let i=0; i < egreso.items.length; i++){
            this.form.detalles.push({
              item_id: egreso.items[i].item_id,
              nombre: egreso.items[i].item.nombre,
              cantidad: egreso.items[i].cantidad
            });
          }
        })
        .catch(error => {
          swal('Error', 'No se pudo cargar el egreso de bodega', 'error');
        });
    },
    inputBodega: function() {
      this.form.bodega_id = null;
      if(this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
    },
    cerrar: function() {
      swal({
        title: "¿Desea cancelar la operación?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar", 
      }).then((result) => {
        if (result.value) {
          this.$emit('cerrar');
        } 
      });
    },
  },
  mounted: function() {
    this.egresoBodegaId && this.cargarEgresoBodega();
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/inventario/EgresoBodega.vue